<form [formGroup]="initUnattendedForm" (ngSubmit)="openConfirmDialog()">

  <div>
    <mat-form-field>
      <mat-label>Lejárati idő</mat-label>
      <input matInput [matDatepicker]="validityDatePicker" formControlName="validityDate">
      <mat-datepicker-toggle matIconSuffix [for]="validityDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #validityDatePicker></mat-datepicker>
    </mat-form-field>
  </div>

  <div>
    <mat-form-field>
      <mat-label>Határidő</mat-label>
      <input matInput [matDatepicker]="deadlinePicker" formControlName="deadline">
      <mat-datepicker-toggle matIconSuffix [for]="deadlinePicker"></mat-datepicker-toggle>
      <mat-datepicker #deadlinePicker></mat-datepicker>
    </mat-form-field>
  </div>

  <div>
    <mat-form-field *ngIf="accounts.length > 0;else no_accounts">
      <mat-label>Kedvezményezett számlaszáma</mat-label>
      <mat-select formControlName="payee">
        @for (account of accounts; track account) {
        <mat-option [value]="account">{{account.accountNumber}} ({{ account.name}})</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <ng-template #no_accounts>
      <mat-form-field>
        <mat-label>Kedvezményezett számlaszáma</mat-label>
        <input matInput formControlName="payee">
      </mat-form-field>
    </ng-template>
    <span *ngIf="initUnattendedForm.controls.payee.value !== null">{{ $any(initUnattendedForm.controls.payee.value).name
      }}</span>
  </div>

  <div formGroupName="payer">
    <mat-form-field>
      <mat-label>Fizető fél számlaszáma</mat-label>
      <input matInput formControlName="accountNumber">
    </mat-form-field>

    <mat-form-field>
      <mat-label>Fizető fél neve</mat-label>
      <input matInput formControlName="name">
    </mat-form-field>
  </div>

  <div>
    <mat-form-field>
      <mat-label>Fizető fél e-mail címe</mat-label>
      <input matInput [disabled]="true">
    </mat-form-field>
  </div>

  <div>
    <mat-form-field>
      <mat-label>Összeg</mat-label>
      <input matInput formControlName="amount" type="number">
    </mat-form-field>

    <mat-slide-toggle formControlName="amountModifiable">Összeg módosítható</mat-slide-toggle>
  </div>

  <mat-form-field>
    <mat-label>Közlemény</mat-label>
    <input matInput formControlName="comment">
  </mat-form-field>

  <mat-card-actions>
    <button mat-flat-button color="primary" type="submit" [disabled]="initUnattendedForm.invalid">KÜLDÉS</button>
  </mat-card-actions>

</form>